// extracted by css-extract-rspack-plugin
export default {"tagCloud":"tagCloud-rjyVc8"};